<template>

  <div class="box">
    <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
    <div v-if="events.length > 0">
      <div class="text-left">
        <!-- <v-chip class="ma-2" color="accent">
        <v-avatar left>
          <v-icon>event</v-icon>
        </v-avatar>
        {{ title }}
      </v-chip> -->
        <v-chip class="ma-2" color="accent">
          <v-avatar left>
            <v-icon>event</v-icon>
          </v-avatar>
          <span v-if="curr_month != null"> {{ curr_month }} </span>
          <span v-else> {{ title }} </span>
        </v-chip>
        <v-chip class="ma-2" color="brand onBrand--text" @click="setToday"
          >Go To Today
        </v-chip>
      </div>
      <v-sheet tile color="grey lighten-3">
        <v-row justify="center" style="margin-left: 10px; margin-right: 10px">
          <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-select
            v-model="type"
            :items="types"
            dense
            outlined
            hide-details
            class="ma-2"
            label="type"
          ></v-select>

          <v-select
            v-model="weekday"
            :items="weekdays"
            dense
            outlined
            hide-details
            label="weekdays"
            class="ma-2"
          ></v-select>

          <v-btn icon class="ma-2" @click="$refs.calendar.next()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </v-sheet>
      <v-sheet height="520">
        <v-calendar
          ref="calendar"
          v-model="value"
          :weekdays="weekday"
          :type="type"
          :events="events"
          :event-overlap-threshold="30"
          :event-color="getEventColor"
          @change="getEvents"
          @click:event="showEvent"
          @click:day="getdata"
          @click:more="viewDay"
        ></v-calendar>
      </v-sheet>
      <template>
        <div class="text-center">
          <v-dialog v-model="dialog" width="500">
            <v-card>
              <v-card-title class="headline" primary-title>
                {{ tempevents.name }}
              </v-card-title>

              <v-card-text>
                <div class="headline mb-2">
                  Description : {{ tempevents.description }}
                </div>
                <v-chip
                  class="mr-2"
                  @click="lights"
                  color="lightgreen"
                  text-color="white"
                >
                  <v-icon left>mdi-brightness-5</v-icon>
                  Class: {{ tempevents.std }}
                </v-chip>
                <v-chip
                  class="mr-2"
                  @click="lights"
                  color="lightgreen"
                  text-color="white"
                >
                  <v-icon left>mdi-brightness-5</v-icon>
                  GRNO: {{ tempevents.grno }}
                </v-chip>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
           <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">View Calendar Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/3dHSngR2IHY?si=GRAvTjTA2atjvXOu"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
        </div>
      </template>
    </div>
  </div>
</template> 
</div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    dialog: false,
    datetime: null,
    title: "",
    type: "month",
    videoDialog:false,
    types: ["month", "week", "day"],
    mode: "stack",
    modes: ["stack", "column"],
    weekday: [0, 1, 2, 3, 4, 5, 6],
    weekdays: [
      { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
      { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] },
      { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
    ],
    value: "",
    events: [],
    tempevents: { name: "", description: "", std: "", grno: "" },
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
    months: [
      "",
      "Jan",
      "Feb",
      "Mar",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    curr_month: null,
  }),
  updated: function () {
    //console.log("Inside updated");
    this.$nextTick().then(() => {
      if (this.$refs.calendar.value != "") {
        console.log(this.$refs.calendar.value);
        let date = this.$refs.calendar.value;
        var no = date.split("-");
        console.log(no[1]);
        this.curr_month = this.months[parseInt(no[1])];
        console.log(this.curr_month);
      }
    });
  },
  methods: {
    viewDay({ date }) {
      this.value = date;
      this.type = "day";
    },
    setToday() {
      this.value = "";
      this.curr_month = null;
    },
    dateTime() {
      let dt = this.formatDate(this.datetime, true);
      const formData = {
        datetime: dt,
      };
      console.log(formData);
      axios
        .post("tryNError/dateTime", formData)
        .then((res) => {
          if (res.data.msg == "200") {
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    showEvent({ nativeEvent, event }) {
      this.tempevents.name = event.name;
      this.tempevents.description = event.description;
      this.tempevents.std = event.std;
      this.tempevents.grno = event.grno;
      this.dialog = true;
      //alert(event.name + " " + event.description + " " + event.std);
    },
    getdata({ day }) {
      // alert(day)
    },
    getEventData(start) {
      return start == this.value;
    },
    getEvents() {
      //alert(this.value)
    },
    getEventColor(event) {
      return event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${
            a.getMonth() + 1
          }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    getMonthYYYYMMDD(date) {
      var num_month = date.split("-");
      var months = [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[parseInt(num_month[1])];
    },
  },
  mounted() {
    this.events.push({
      name: "Happy New Year", //title
      start: "2020-01-01", //this.formatDate(res.data.date, !true),
      end: "2020-01-01", //this.formatDate(res.data.date, !true),
      color: "",
      description: "",
      std: "",
      div: "",
    });
    axios
      .get("parent/getCalendar")
      .then((res) => {
        if (res.data.msg == "200") {
          if (res.data.eventInfo.length !== 0) {
            this.events = res.data.eventInfo;
            console.log(this.events);
          }
          //   this.events.push({
          //         name: "vikas",//title
          //         start: res.data.date,//this.formatDate(res.data.date, !true),
          //         end: res.data.date,//this.formatDate(res.data.date, !true),
          //         color: "red",
          //         description:"More Info...",
          //         std:"UKG",
          //         div:"A",
          //     })
          this.title = this.getMonthYYYYMMDD(this.$refs.calendar.start);
        } else {
        }
      })
      .catch((error) => {
        window.console.log(error);
      });
  },
};
</script>
